import React from 'react';

const EDGE_CTA_URL =
  'https://www.benzinga.com/premium/ideas/benzinga-edge-5?utm_ad=market-update&utm_adType=paywall&utm_campaign=volatility';

export const MarketUpdateTableCTA: React.FC = () => {
  return (
    <a
      href={EDGE_CTA_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1] no-underline"
      aria-label="Unlock with Benzinga Edge"
    >
      <div className="bg-[#0c1c33] text-white rounded-lg px-6 py-4 shadow-lg max-w-sm text-center border border-blue-100">
        <p className="font-semibold text-sm mb-2 text-white">Unlock full data with Benzinga Edge</p>
        <span className="inline-block bg-[#3f83f8] text-white text-sm font-semibold px-4 py-2 rounded-md hover:opacity-90">
          Get Edge Access
        </span>
      </div>
    </a>
  );
};
